import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

// Pages that don't require email verification
const SKIP_VERIFY_PATHS = ['/choose-plan', '/payment', '/verify-email'];

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Skip email verification check for plan selection and payment pages
  if (user && user.emailVerified === false && !SKIP_VERIFY_PATHS.includes(location.pathname)) {
    return <Navigate to="/verify-email" replace />;
  }

  return <>{children}</>;
}
